export default {
  CAMPAIGNS_TITLE: 'Campaigns',
  CAMPAIGNS_TITLE_ICON_ALT: 'Campaigns icon',
  FETCH_CAMPAIGNS_ERROR: 'There was a problem fetching campaigns',
  FETCH_CAMPAIGN_CONTRIBUTIONS_ERROR:
    'There was a problem fetching campaign contributions',
  CREATE_CAMPAIGN_SUCCESS_MESSAGE: 'Your campaign was successfully created.',
  CREATE_CAMPAIGN_ERROR_MESSAGE: 'There was a problem creating campaign {name}',
  UPDATE_CAMPAIGN_ERROR_MESSAGE: 'There was a problem updating campaign {name}',
  FETCH_CAMPAIGN_EVENTS_ERROR: 'There was a problem fetching campaign events',
  CREATE_CAMPAIGN_EVENT_ERROR_MESSAGE:
    'There was a problem creating campaign event {name}',
  CREATE_CAMPAIGN_EVENT_TICKET_OPTION_ERROR_MESSAGE:
    'There was a problem creating ticket option {name}',
  UPDATE_CAMPAIGN_EVENT_TICKET_OPTION_ERROR_MESSAGE:
    'There was a problem updating ticket option {name}',
  UPDATE_CAMPAIGN_EVENT_ERROR_MESSAGE: 'There was a problem updating {name}',
  EDIT_CAMPAIGN_TITLE: 'Edit Campaign',
  CREATE_NEW_CAMPAIGN_TITLE: 'Create New Campaign',
  CAMPAIGN_FORM_FIX_ERRORS_MESSAGE: 'Fix errors to save the data',
  CAMPAIGN_NAME_LABEL: 'Campaign Name',
  CAMPAIGN_NAME_REQUIRED_LABEL: 'Campaign Name Required',
  CAMPAIGN_DISPLAY_NAME_LABEL: 'Display Name',
  CAMPAIGN_DESCRIPTION_LABEL: 'Campaign Description',
  CAMPAIGN_WEBSITE_LABEL: 'Campaign Website',
  CAMPAIGN_CATEGORY_LABEL: 'Campaign Category',
  CAMPAIGN_GOAL_LABEL: 'Campaign Goal',
  CAMPAIGN_GENERAL_LABEL: 'General',
  CAMPAIGN_CROWDFUNDING_LABEL: 'Crowdfunding',
  CAMPAIGN_PEER_TO_PEER_LABEL: 'Peer-to-Peer',
  CAMPAIGN_EVENT_LABEL: 'Event',
  CAMPAIGN_REGISTRATION_LABEL: 'Registration w/ Fundraising',
  CAMPAIGN_MONETARY_LABEL: 'Monetary',
  CAMPAIGN_IN_KIND_LABEL: 'In-kind',
  CAMPAIGN_GOAL_AMOUNT_LABEL: 'Goal',
  CAMPAIGN_GOAL_AMOUNT_REQUIRED_LABEL: 'Goal Required',
  CAMPAIGN_STRETCH_GOAL_LABEL: 'Stretch Goal',
  CAMPAIGN_STRETCH_GOAL_REQUIRED_LABEL: 'Stretch Goal Required',
  CAMPAIGN_START_DATE_LABEL: 'Start Date',
  CAMPAIGN_END_DATE_LABEL: 'End Date',
  CAMPAIGN_EVENT_LOCATION_LABEL: 'Event Location',
  CAMPAIGN_EVENT_LOCATION_REQUIRED_LABEL: 'Event Location Required',
  CAMPAIGN_EVENT_DATE_LABEL: 'Event Date',
  CAMPAIGN_TICKET_PRICE_LABEL: 'Ticket Price',
  CAMPAIGN_TICKET_PRICE_REQUIRED_LABEL: 'Ticket Price Required',
  CAMPAIGN_TICKET_AVAILABLE_LABEL: 'Tickets Available',
  CAMPAIGN_TICKET_AVAILABLE_REQUIRED_LABEL: 'Tickets Available Required',
  CAMPAIGN_ITEM_TYPE_LABEL: 'Item Type',
  CAMPAIGN_ITEM_TYPE_REQUIRED_LABEL: 'Item Type Required',
  CAMPAIGN_NUMBER_OF_ITEMS_LABEL: 'Number of Items',
  CAMPAIGN_NUMBER_OF_ITEMS_REQUIRED_LABEL: 'Number of Items Required',
  CAMPAIGN_ESTIMATED_ITEM_VALUE_LABEL: 'Estimated Item Value',
  CAMPAIGN_ESTIMATED_ITEM_VALUE_REQUIRED_LABEL: 'Estimated Item Value Required',
  CAMPAIGN_ESTIMATED_VALUE_LABEL: 'Estimated Value',
  CAMPAIGN_ADMINISTRATORS_LABEL: 'Campaign Administrators',
  CAMPAIGN_ACTIVITY_TAB: 'Activity',
  CAMPAIGN_EVENTS_TAB: 'Events',
  CAMPAIGN_CONTRIBUTIONS_TAB: 'Contributions',
  CAMPAIGN_TOTAL_AMOUNT_CONTRIBUTED_LABEL: 'Total Amount Contributed',
  CAMPAIGN_TOTAL_NUMBER_OF_DONORS_LABEL: 'Total # of Contributors',
  CAMPAIGN_AVG_CONTRIBUTION_LABEL: 'Avg Contribution',
  CAMPAIGN_LARGEST_CONTRIBUTION_LABEL: 'Largest Contribution',
  CAMPAIGN_NEW_DONORS_LABEL: 'New Donors',
  CAMPAIGN_RETURN_DONORS_LABEL: 'Return Donors',
  CAMPAIGN_GOAL_AMOUNT_VALUE_LABEL: 'Goal: {value}',
  CAMPAIGN_DETAILS_CAMPAIGN_CREATED:
    '<link-to-campaign>{displayName}</link-to-campaign> was created{source, select, classy { through <strong>Classy</strong>} stripe { through <strong>Stripe</strong>} pledge { through <strong>Pledge</strong>} other {}}',
  CAMPAIGN_DETAILS_CAMPAIGN_GOAL_MET:
    '<link-to-campaign>{displayName}</link-to-campaign> goal has been met! {congratulationsIcons}',
  CAMPAIGN_DETAILS_CAMPAIGN_STRETCH_GOAL_ADDED:
    '<link-to-campaign>{displayName}</link-to-campaign> has a new stretch goal of {amount}',
  CAMPAIGN_DETAILS_CAMPAIGN_STRETCH_GOAL_MET:
    '<link-to-campaign>{displayName}</link-to-campaign> stretch goal has been met!',
  CAMPAIGN_DAYS_TILL_EVENT_LABEL: '{days} till event',
  CAMPAIGN_DAYS_TILL_START_LABEL: '{days} till start',
  CAMPAIGN_DAYS_LEFT_LABEL: '{days} left',
  CAMPAIGN_TOTAL_DAYS_LABEL: 'Total: {days}',
  CAMPAIGNS_SEARCH_PLACEHOLDER: 'Search Campaigns',
  ADD_CAMPAIGN_LABEL: 'Add New Campaign',
  CAMPAIGNS_SHOW_ARCHIVED_LABEL: 'Show Archived',
  CAMPAIGNS_SHOW_COMPLETED_LABEL: 'Show Completed',
  CAMPAIGNS_CARD_ACTIONS_TITLE: 'Campaign Card Actions',
  CAMPAIGNS_EDIT_ACTION_LABEL: 'Edit',
  CAMPAIGNS_DUPLICATE_ACTION_LABEL: 'Duplicate',
  CAMPAIGNS_ACTIVATE_ACTION_LABEL: 'Activate Campaign',
  CAMPAIGNS_ARCHIVE_ACTION_LABEL: 'Archive',
  CAMPAIGNS_COMPLETE_ACTION_LABEL: 'Mark as Complete',
  CAMPAIGNS_DELETE_ACTION_LABEL: 'Delete',
  CAMPAIGN_DETAILS: 'Details',
  CAMPAIGN_DETAILS_EDIT: 'Edit',
  CAMPAIGN_DETAILS_WEBSITE: 'Campaign Website',
  CAMPAIGN_DETAILS_CATEGORY: 'Campaign Category',
  CAMPAIGN_DETAILS_GOAL_TYPE: 'Goal Type',
  CAMPAIGN_DETAILS_GOAL: 'Goal',
  CAMPAIGN_DETAILS_STRETCH_GOAL: 'Stretch Goal',
  CAMPAIGN_DETAILS_START_DATE: 'Start Date',
  CAMPAIGN_DETAILS_END_DATE: 'End Date',
  CAMPAIGN_DETAILS_ADMINISTRATORS: 'Administrators',
  CAMPAIGNS_REMOVE_DESCRIPTION:
    'Are you sure you want to delete this this campaign?',
  REMOVE_CAMPAIGN_ERROR: 'There was a problem removing a campaign',
  CAMPAIGNS_FISCAL_GOAL_TITLE: 'Fiscal Goal',
  CAMPAIGNS_GOAL_TOTAL_LABEL: 'Goal Total',
  UPDATE_CAMPAIGN_FISCAL_GOAL_ERROR:
    'There was a problem updating a fiscal goal',
  CAMPAIGNS_SET_ANNUAL_GOAL_TITLE: 'Set Your Annual Goal - {year}',
  CAMPAIGNS_TOTAL_REVENUE_LABEL: 'Total Campaign Revenue',
  CAMPAIGNS_TOTAL_CAMPAIGN_CONTRIBUTIONS: 'Total Campaign Contributions',
  CAMPAIGNS_TOTAL_EARNED_REVENUE: 'Total Earned Revenue',
  CAMPAIGNS_TOTAL_DONATIONS: 'Total Donations',
  CAMPAIGNS_TOTAL_DONORS_LABEL: 'Total Donors',
  CAMPAIGNS_TOTAL_CONTRIBUTORS_LABEL: 'Total Contributors',
  CAMPAIGNS_TOTAL_GOAL_PERCENTAGE_LABEL: 'of total goal',
  CAMPAIGN_DONATION_AMOUNT_LABEL: 'Amount',
  CAMPAIGN_DONATION_METHOD_LABEL: 'Method',
  CAMPAIGN_DONATION_DONOR_NAME_LABEL: 'Constituent',
  CAMPAIGN_DONATION_TYPE_LABEL: 'Type',
  CAMPAIGN_DONATION_SOURCE_LABEL: 'Source',
  CAMPAIGN_DONATION_DATE_LABEL: 'Date',
  CAMPAIGN_SEARCH_DONORS_LABEL: 'Search Constituents',
  ALL_CAMPAIGNS_LABEL: 'All Campaigns',
  CAMPAIGN_BAR_GOAL_LABEL: 'Goal',
  CAMPAIGN_UPDATE_SUCCESS: 'Campaign successfully updated',
  CAMPAIGN_EVENT_CREATE_SUCCESS: 'Campaign event successfully created',
  CAMPAIGN_EVENT_UPDATE_SUCCESS: 'Campaign event successfully updated',
  CAMPAIGN_EVENT_TICKET_OPTION_CREATE_SUCCESS:
    'Ticket option successfully created',
  CAMPAIGN_EVENT_TICKET_OPTION_UPDATE_SUCCESS:
    'Ticket option successfully updated',
  CAMPAIGN_UPDATE_FAILURE: 'Error, campaign update failed',
  CAMPAIGN_DELETE_SUCCESS: 'Campaign successfully deleted',
  CAMPAIGN_DELETE_FAILURE: 'Error, campaign deletion failed',
  CAMPAIGN_CREATE_SUCCESS: 'Campaign successfully created',
  CAMPAIGN_CREATE_FAILURE: 'Error, campaign creation failed',
  CAMPAIGN_FILTER_BY_ADMINS: 'Filter by Admins',
  CAMPAIGN_INPUT_DATES_TO_SEARCH_FROM: 'Input dates to search from',
  CAMPAIGN_FILTER_BY_TOTAL_NUMBER_OF_DONORS:
    'Filter by Total Number of Contributors',
  CAMPAIGN_FILTER_BY_TOTAL_CAMPAIGN_CONTRIBUTIONS:
    'Filter by Total Campaign Contributions',
  CAMPAIGN_FILTER_ASSIGNED_TO_ME: 'Assigned to Me',
  CAMPAIGN_FILTER_ALL_ASSIGNED: 'All Assigned Campaigns',
  CAMPAIGN_FILTER_ALL_UNASSIGNED: 'All Unassigned Campaigns',
  CAMPAIGN_FILTER_SHOW_ALL: 'Show all',
  CAMPAIGN_SORT_NEWEST: 'Newest to Oldest',
  CAMPAIGN_SORT_OLDEST: 'Oldest to Newest',
  PIN_CAMPAIGN: 'Pin Campaign',
  CAMPAIGN_CARDS_ACTIONS_TITLE: 'Campaign Actions',
  CAMPAIGN_FUNDRAISER_PAGE: 'Fundraiser Page',
  CAMPAIGN_FUNDRAISER_GOAL: 'Fundraiser Page Goal',
  CAMPAIGN_FUNDRAISER_GOAL_NOT_SET: 'not set',
  CAMPAIGN_FUNDRAISER_TEXT_KEYWORD: 'Text to donate Keyword',
  CAMPAIGN_ADD_FUNDRAISER: 'Add Fundraising Page',
  CAMPAIGN_EDIT_FUNDRAISER: 'Edit Fundraiser Page',
  CAMPAIGN_SHARE_FUNDRAISER:
    '{draft, select, true {Publish/} other {}}Share Fundraiser Page',
  CAMPAIGN_DELETE_FUNDRAISER: 'Delete Fundraising Page',
  CAMPAIGN_DELETE_FUNDRAISER_DESC:
    'Deleting this fundraising page will permanently remove it from the campaign.',
  CAMPAIGN_DELETE_FUNDRAISER_CONFIRM:
    'Are you sure you want to delete this fundraising page?',
  CAMPAIGN_FUNDRAISER_DELETE_SUCCESS: 'Fundraiser Successfully Deleted',
  CAMPAIGN_FUNDRAISER_DELETE_FAILURE: 'Error, fundraiser delete failed',
  CAMPAIGN_CREATE_EVENT: 'Create Event',
  CAMPAIGN_EDIT_EVENT: 'Edit Event',
  CAMPAIGN_SEE_ALL_EVENTS: 'See All Events',
  CAMPAIGN_EVENT: 'Event',
  CAMPAIGN_EVENT_NAME: 'Event Name',
  CAMPAIGN_EVENT_NAME_REQUIRED: 'Event Name Required',
  CAMPAIGN_EVENT_WEBSITE: 'Event Website',
  CAMPAIGN_EVENT_ORGANIZERS: 'Organizers',
  CAMPAIGN_EVENT_TIMEZONE: 'Timezone',
  CAMPAIGN_EVENT_LOCATION: 'Location',
  CAMPAIGN_EVENT_LOCATION_URL: 'Location URL',
  CAMPAIGN_EVENT_VENUE: 'Venue',
  CAMPAIGN_EVENT_VENUE_ADDRESS: 'Venue Address',
  CAMPAIGN_EVENT_ONLINE: 'Online Event',
  CAMPAIGN_EVENT_TBA: 'To be announced',
  CAMPAIGN_EVENT_SCHEDULE: 'Schedule',
  CAMPAIGN_EVENT_TICKET_OPTION: 'Ticket Option',
  CAMPAIGN_EVENT_TICKET_OPTIONS: 'Ticket Options',
  CAMPAIGN_EVENT_CREATE_TICKET: 'Create Ticket',
  CAMPAIGN_EVENT_EDIT_TICKET: 'Edit Ticket',
  CAMPAIGN_EVENT_TICKET_NAME: 'Ticket Name',
  CAMPAIGN_EVENT_TICKET_NAME_REQUIRED: 'Ticket Name Required',
  CAMPAIGN_EVENT_TICKET_TYPE: 'Ticket Type',
  CAMPAIGN_EVENT_TICKET_PRICE: 'Price',
  CAMPAIGN_EVENT_TICKET_PRICE_REQUIRED: 'Price Required',
  CAMPAIGN_EVENT_TICKET_FMV: 'Fair Market Value',
  CAMPAIGN_EVENT_TICKET_FMV_REQUIRED: 'Fair Market Value Required',
  CAMPAIGN_EVENT_TICKET_QTY: 'Quantity',
  CAMPAIGN_EVENT_TICKET_FREE: 'Free',
  CAMPAIGN_EVENT_TICKET_PAID: 'Paid',
  CAMPAIGN_EVENT_TICKET_VARIES: 'Varies',
  CAMPAIGN_EVENT_TICKET_SOLD_AVAILABLE: 'Sold/Available',
  CAMPAIGN_EVENT_TICKET_UNLIMITED: 'Unlimited',
  CAMPAIGN_EVENT_TICKET_QTY_HELPER_TEXT: 'Leave blank for unlimited tickets.',
  CAMPAIGN_EVENT_ALL: 'All Events ({count})',
  CAMPAIGN_EVENT_DONATION_AMOUNT: 'Donation Amount',
  CAMPAIGN_EVENT_MOVE_EVENT: 'Move Campaign Event',
  CAMPAIGN_EVENT_MOVE_EVENT_DESCRIPTION:
    'You can move this event to a different campaign by selecting it from the list below. Moving an event will move the event, tickets and all contributions associated to the event.',
  CAMPAIGN_EVENT_MOVE_UPDATE_SUCCESS:
    'Campaign event has been successfully moved to campaign {name}.',
  CAMPAIGN_EVENT_MOVE_UPDATE_ERROR:
    'There was an error moving campaign event {eventName}.',
};
